import { defineStore } from 'pinia'
import baseService from '@/utils/http/axios'

export interface StoreTypeItem {
  id: string | number
  parentId: string | number
  typeGroup: string
  typeName: string
  sortOrder: number
  status: string
  children?: StoreTypeItem[]
  createByName?: string
  modifyTime?: string
}

export const useStoreType = defineStore('storeType', {
  state: () => ({}),
  actions: {
    // 分页查询店铺类型
    async getStoreTypePage(params: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/storeType/page',
          method: 'get',
          params
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 店铺类型详情
    async getStoreTypeInfo(id: string | number) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: `/console/storeType/info/${id}`,
          method: 'get'
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 新增店铺类型
    async createStoreType(data: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/storeType/create',
          method: 'post',
          data
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 编辑店铺类型
    async updateStoreType(data: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/storeType/update',
          method: 'post',
          data
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 删除店铺类型
    async deleteStoreType(id: string | number) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: `/console/storeType/del/${id}`,
          method: 'post'
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 查询二级树
    async getStoreTypeTree(params: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/storeType/tree',
          method: 'get',
          params
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 按父级查询下拉列表
    async listByParent(params: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/storeType/listByParent',
          method: 'get',
          params
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
})
